import { render, staticRenderFns } from "./VehiculesCanauxPrixAnnonceFrom.vue?vue&type=template&id=0573b766&scoped=true&"
import script from "./VehiculesCanauxPrixAnnonceFrom.vue?vue&type=script&lang=js&"
export * from "./VehiculesCanauxPrixAnnonceFrom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0573b766",
  null
  
)

export default component.exports